import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Avatar,
  Button,
  Grid,
  Modal
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import { GoogleMap, Marker, Autocomplete } from '@react-google-maps/api';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import WorkerClockingHistoryModal from "../components/WorkerClockingHistoryModal";
import worker from '../Img/worker.jpg';
import { collection, collectionGroup, getDocs, doc, updateDoc, query, where, getDoc, setDoc, deleteDoc, deleteField, writeBatch, onSnapshot } from 'firebase/firestore';
import { auth, db, sendApprovalEmail } from '../Firebase';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import EmailIcon from '@mui/icons-material/Email';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import MailOutlineIcon from '@mui/icons-material/MailOutline'; 
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import Badge from '@mui/material/Badge';
import CircularProgress from '@mui/material/CircularProgress';
import PersonIcon from '@mui/icons-material/Person';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MessageIcon from '@mui/icons-material/Message';
import workerProfile from '../Img/workerProfile.png';
import emptyImage from '../Img/empty.png';
import MapImg from '../Img/map.png'; 
import { normalizeToHMinS } from "../utils/timeFormat";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 700,
  bgcolor: 'white',
  boxShadow: 24,
  p: 3,
  borderRadius: 2,
};



function AdminClockingReport() {
  
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const [users, setUsers] = useState([]);
  const [openSettings, setOpenSettings] = useState(false);
  const [openMessages, setOpenMessages] = useState(false);
  const [openApprovals, setOpenApprovals] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMessagesCount, setNewMessagesCount] = useState(0);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [newUsersCount, setNewUsersCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [clockInsToday, setClockInsToday] = useState(0);
  const [activeWorkers, setActiveWorkers] = useState(0);
  const [onTimeWorkers, setOnTimeWorkers] = useState(0);
  const [violationsToday, setViolationsToday] = useState(0);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [clockingHistoryLoading, setClockingHistoryLoading] = useState(false);
  const [usersWithNotesToday, setUsersWithNotesToday] = useState(new Set());
  const [clockingHistory, setClockingHistory] = useState([]);
  const [showSiteForm, setShowSiteForm] = useState(false);
  const [sites, setSites] = useState([]);
  const [selectedSiteId, setSelectedSiteId] = useState('');
  const [newSiteName, setNewSiteName] = useState('');
  const [newSiteStartDate, setNewSiteStartDate] = useState("");
  const [newSiteEndDate, setNewSiteEndDate] = useState("");
  const [newStartTime, setNewStartTime] = useState('');
  const [newEndTime, setNewEndTime] = useState('');
  const [siteAssignments, setSiteAssignments] = useState({});
  const [autocompleteReady, setAutocompleteReady] = useState(false);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState({ lat: 45.5019, lng: -73.5674 });
  const [place, setPlace] = useState('');
  const [autocomplete, setAutocomplete] = useState(null);
  const [searchAddress, setSearchAddress] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [geocoder, setGeocoder] = useState(null);
  const [openDeleteSiteModal, setOpenDeleteSiteModal] = useState(false);
  const [deleteTargetSite, setDeleteTargetSite] = useState(null); 
  const [deletingSite, setDeletingSite] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isFormComplete = newSiteName && newSiteStartDate && newSiteEndDate && newStartTime && newEndTime && marker?.lat && marker?.lng;
  const [deleteTargetUser, setDeleteTargetUser] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedUserDetails, setSelectedUserDetails] = useState(null);
  const [forceClockingOut, setForceClockingOut] = useState(false);
  const [openEditSiteModal, setOpenEditSiteModal] = useState(false);
  const [editTargetSite, setEditTargetSite] = useState(null);
  const [editSiteName, setEditSiteName] = useState("");
  const [editSiteStartDate, setEditSiteStartDate] = useState("");
  const [editSiteEndDate, setEditSiteEndDate] = useState("");
  const [editStartTime, setEditStartTime] = useState("");
  const [editEndTime, setEditEndTime] = useState("");
  const [updatingSite, setUpdatingSite] = useState(false);

  const formatWorkerDisplayName = (fullName = "") => {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "";

    const firstNameRaw = parts[0];
    const firstName =
      firstNameRaw.charAt(0).toUpperCase() + firstNameRaw.slice(1).toLowerCase();
    const lastName = parts.slice(1).join(" ").toUpperCase();

    return lastName ? `${firstName} ${lastName}` : firstName;
  };



  // Fetch users report data:
  useEffect(() => {
    const selectedSite = sites.find(s => s.id === selectedSiteId);

    const fetchClockingData = async () => {
      setLoadingUsers(true); 
      const todayISO = getTodayISO();       
      const todayDMY = getTodayDDMMYYYY();  
      const usersSnapshot = await getDocs(collection(db, 'users'));
      const siteSnapshot = await getDocs(collection(db, 'ConstructionSites'));
      const selectedSite = siteSnapshot.docs[0]?.data();
      const workingStartThreshold = selectedSite?.startTime || '08:00';
      const workingEndThreshold = selectedSite?.endTime || '17:00';
      const results = [];
      const usersWithNotes = new Set();

      const clockingGroupQuery = query(
        collectionGroup(db, "clocking history"),
        where("date", "in", [todayISO, todayDMY])
      );
      const clockingGroupSnap = await getDocs(clockingGroupQuery);
      const clockingByUserId = new Map();

      clockingGroupSnap.forEach((docSnap) => {
        const data = docSnap.data();
        const userId = docSnap.ref.parent?.parent?.id;
        if (!userId) return;
        if (!clockingByUserId.has(userId)) {
          clockingByUserId.set(userId, []);
        }
        clockingByUserId.get(userId).push(data);
      });

      for (const userDoc of usersSnapshot.docs) {
        const userData = userDoc.data();

        // Check and initialize isClockedIn if missing
        if (userData.role === 'worker') {
          const userRef = doc(db, 'users', userDoc.id);
          if (userData.isClockedIn === undefined) {
            await updateDoc(userRef, {
              isClockedIn: false,
            });
          }
        }

        const isClockedIn = userData.isClockedIn;

        if (userData.role !== 'worker' || userData.isApproved !== true) continue;

        const fullName = userData.fullName;

        const todayEntries = clockingByUserId.get(userDoc.id) || [];
        const clockIn = todayEntries.find(e => e.type === 'Clock In');
        const clockOut = todayEntries.find(e => e.type === 'Clock Out');

        let hoursWorked = '';
        if (clockIn?.time && clockOut?.time) {
          const inHHMMSS = toTimeHHMMSS(clockIn.time);
          const outHHMMSS = toTimeHHMMSS(clockOut.time);

          if (inHHMMSS && outHHMMSS) {
            const inTime = hhmmssToDate(inHHMMSS);
            const outTime = hhmmssToDate(outHHMMSS);

            const diff = (outTime - inTime) / 60000;

            if (Number.isFinite(diff) && diff >= 0) {
              const hrs = Math.floor(diff / 60);
              const mins = Math.floor(diff % 60);
              hoursWorked = `${hrs} h ${mins} m`;
            } else {
              hoursWorked = '';
            }
          }
        }

        // Inside your user loop:
        if ((clockIn?.note && clockIn.note !== '—') || (clockOut?.note && clockOut.note !== '—')) {
          usersWithNotes.add(userDoc.id);
        }
        results.push({
          id: userDoc.id,
          name: fullName,
          clockInTime: normalizeToHMinS(clockIn?.time) || '',
          clockOutTime: normalizeToHMinS(clockOut?.time) || '',
          clockInLocation: clockIn?.type === 'Clock In' ? clockIn.location : '',
          clockOutLocation: clockOut?.type === 'Clock Out' ? clockOut.location : '',
          status: clockOut ? t('Clocked Out') : clockIn ? t('Clocked In') : t('Absent'),
          hoursWorked,
          isClockedIn,
        });
      }

      setUsers(results);
      setUsersWithNotesToday(usersWithNotes);

      // Stats for the admin: clock-ins, on-time, violations, active
      let clockInsCount = 0;
      let activeCount = 0;
      let onTimeCount = 0;
      let violationsCount = 0;

      for (const userDoc of usersSnapshot.docs) {
        const userData = userDoc.data();
        if (userData.role !== 'worker' || userData.isApproved !== true) continue;

        if (userData.isClockedIn) activeCount++;

        const entries = clockingByUserId.get(userDoc.id) || [];
        const clockInEntry = entries.find(e => e.type === 'Clock In');
        const clockOutEntry = entries.find(e => e.type === 'Clock Out');

        if (!clockInEntry && !clockOutEntry) {
          violationsCount++;
        }

        if (clockInEntry) {
          clockInsCount++;

        const inHHMMSS = toTimeHHMMSS(clockInEntry.time);
        const startHHMMSS = toTimeHHMMSS(workingStartThreshold);

        if (inHHMMSS && startHHMMSS) {
          const diffMin = (hhmmssToDate(inHHMMSS) - hhmmssToDate(startHHMMSS)) / 60000;
          if (diffMin <= 10) onTimeCount++;     // <= 10 min late counts as on-time (your logic)
          else violationsCount++;
        }
        }

        if (clockOutEntry) {
        const outHHMMSS = toTimeHHMMSS(clockOutEntry.time);
        const endHHMMSS = toTimeHHMMSS(workingEndThreshold);

        if (outHHMMSS && endHHMMSS) {
          const diffMin = (hhmmssToDate(outHHMMSS) - hhmmssToDate(endHHMMSS)) / 60000;
          if (diffMin > 10) violationsCount++; // Late clock-out
          else if (diffMin < 0) violationsCount++; // Early clock-out
        }
        }
      }

      setClockInsToday(clockInsCount);
      setActiveWorkers(activeCount);
      setOnTimeWorkers(onTimeCount);
      setViolationsToday(violationsCount);
      setLoadingUsers(false); 
    };

    fetchClockingData();
  }, []);


  
  // Fetch Admin NEW USERS and NEW MESSAGES notifications
  useEffect(() => {
    const notifRef = doc(db, "AdminNotifications", "main");

    const unsub = onSnapshot(
      notifRef,
      (snap) => {
        if (!snap.exists()) {
          setNewUsersCount(0);
          setNewMessagesCount(0);
          return;
        }
        const data = snap.data();
        setNewUsersCount(data.newUsers || 0);
        setNewMessagesCount(data.newMessages || 0);
      },
      (err) => {
        console.error("AdminNotifications listener failed:", err);
      }
    );

    return () => unsub();
  }, []);


  const toTimeHHMMSS = (timeStr) => {
    if (!timeStr) return null;

    const s = String(timeStr).trim();

    const hmsMatch = s.match(/(\d{1,2})\s*h\s*(\d{1,2})\s*min(?:\s*(\d{1,2})\s*s)?/i);
    if (hmsMatch) {
      const hh = String(hmsMatch[1]).padStart(2, "0");
      const mm = String(hmsMatch[2]).padStart(2, "0");
      const ss = String(hmsMatch[3] ?? "0").padStart(2, "0");
      return `${hh}:${mm}:${ss}`;
    }

    if (!s.includes("AM") && !s.includes("PM") && s.includes(":")) {
      const parts = s.split(":").map((p) => p.trim());
      if (parts.length === 2) {
        const [hh, mm] = parts;
        return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}:00`;
      }
      if (parts.length === 3) {
        const [hh, mm, ss] = parts;
        return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
      }
    }

    if (s.includes("AM") || s.includes("PM")) {
      const [time, mod] = s.split(" ");
      let [h, m] = time.split(":");
      if (h === "12") h = "00";
      if (mod === "PM") h = String(parseInt(h, 10) + 12);
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00`;
    }

    return null;
  };

  const hhmmssToDate = (hhmmss) => new Date(`2000-01-01T${hhmmss}`);


  // Always use ISO local date: YYYY-MM-DD (matches your stored history date like 2026-01-12)
  const getTodayISO = () => {
    const now = new Date();
    const tzOffsetMs = now.getTimezoneOffset() * 60000;
    return new Date(now.getTime() - tzOffsetMs).toISOString().slice(0, 10);
  };

  // "21/01/2026"
  const getTodayDDMMYYYY = () => {
    const now = new Date();
    const tzOffsetMs = now.getTimezoneOffset() * 60000;
    const local = new Date(now.getTime() - tzOffsetMs);

    const dd = String(local.getDate()).padStart(2, "0");
    const mm = String(local.getMonth() + 1).padStart(2, "0");
    const yyyy = local.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };


  // Format current time like: "05 h 54 min 38 s" (matches your DB style)
  const formatNowAsHMinS = () => {
    const now = new Date();
    const hh = String(now.getHours()).padStart(2, "0");
    const mm = String(now.getMinutes()).padStart(2, "0");
    const ss = String(now.getSeconds()).padStart(2, "0");
    return `${hh} h ${mm} min ${ss} s`;
  };

  // Bulk force clock-out: all workers still clocked-in
  const handleForceClockOutAll = async () => {
    if (forceClockingOut) return;

    setForceClockingOut(true);
    try {
      const today = getTodayISO();
      const nowIso = new Date().toISOString();
      const outTime = "00 h 00 min 00 s";

      // 1) Get all currently clocked-in workers
      const qWorkers = query(
        collection(db, "users"),
        where("role", "==", "worker"),
        where("isApproved", "==", true),
        where("isClockedIn", "==", true)
      );

      const snap = await getDocs(qWorkers);
      if (snap.empty) {
        // Nothing to do
        return;
      }

      // 2) For each worker, ensure they don't already have a "Clock Out" for today
      //    Then: add Clock Out entry + set isClockedIn false
      const candidates = [];

      for (const u of snap.docs) {
        const uid = u.id;

        const outQ = query(
          collection(db, "users", uid, "clocking history"),
          where("date", "==", today),
          where("type", "==", "Clock Out")
        );

        const outSnap = await getDocs(outQ);

        candidates.push({
          uid,
          hasClockOutToday: !outSnap.empty,
        });
      }

      // 3) Batch writes in chunks (2 ops per worker: set history doc + update user doc)
      const CHUNK_USERS = 200; // 200 users => 400 writes (safe under 500)
      for (let i = 0; i < candidates.length; i += CHUNK_USERS) {
        const batch = writeBatch(db);
        const slice = candidates.slice(i, i + CHUNK_USERS);

        slice.forEach(({ uid, hasClockOutToday }) => {
          const userRef = doc(db, "users", uid);

          // Always set user as clocked-out
          batch.update(userRef, { isClockedIn: false });

          // Only create a new Clock Out entry if it doesn't already exist today
          if (!hasClockOutToday) {
            const historyRef = doc(collection(db, "users", uid, "clocking history"));
            batch.set(historyRef, {
              date: today,
              type: "Clock Out",
              time: outTime,
              timestamp: nowIso,
              location: "—",
              locationCoords: { lat: null, lng: null },
              note: "Pointage effectué par l’administrateur",
            });
          }
        });

        await batch.commit();
      }

      // 4) Update UI immediately (optional but recommended)
      setUsers((prev) =>
        prev.map((u) =>
          u.isClockedIn
            ? { ...u, isClockedIn: false, status: t("Clocked Out") }
            : u
        )
      );

      // If you want the stats to reflect immediately
      setActiveWorkers(0); // quick fallback; or recompute properly if you prefer

    } catch (err) {
      console.error("Force clock-out failed:", err);
    } finally {
      setForceClockingOut(false);
    }
  };


  // Convert timing into AM/PM" 
  const convertTo24 = (timeStr) => {
    if (!timeStr) return "";
    // If already 24h like "06:04:31" or "06:04"
    if (!timeStr.includes("AM") && !timeStr.includes("PM")) return timeStr;

    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");

    if (hours === "12") hours = "00";
    if (modifier === "PM") hours = String(parseInt(hours, 10) + 12);

    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
  };

  
  // Fetch Construction Sites
  const fetchSites = async () => {
    const snap = await getDocs(collection(db, 'ConstructionSites'));
    const siteList = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setSites(siteList);
  };

  useEffect(() => {
    fetchSites();
  }, []);

  
  // Edit the Site
  const openEditSite = (site) => {
    setEditTargetSite(site);

    setEditSiteName(site.name || "");
    setEditSiteStartDate(site.siteStartDate || "");
    setEditSiteEndDate(site.siteEndDate || "");
    setEditStartTime(site.startTime || "");
    setEditEndTime(site.endTime || "");
    setOpenEditSiteModal(true);
  };


  // Update construction site in Firestore
  const updateConstructionSite = async () => {
    if (!editTargetSite?.id) return;

    setUpdatingSite(true);
    try {
      const siteRef = doc(db, "ConstructionSites", editTargetSite.id);

      await updateDoc(siteRef, {
        name: editSiteName,
        siteStartDate: editSiteStartDate,
        siteEndDate: editSiteEndDate,
        startTime: editStartTime,
        endTime: editEndTime,
      });

      await fetchSites();
      setOpenEditSiteModal(false);
      setEditTargetSite(null);
    } catch (err) {
      console.error("Failed to update site:", err);
    } finally {
      setUpdatingSite(false);
    }
  };


  // Delete a ConstructionSite and remove assignedSiteId for all users that reference it
  const deleteConstructionSite = async (siteId) => {
    setDeletingSite(true);
    try {
      // 1) Delete the site doc
      const siteRef = doc(db, 'ConstructionSites', siteId);

      // 2) Find all users assigned to this site
      const usersQ = query(collection(db, 'users'), where('assignedSiteId', '==', siteId));
      const usersSnap = await getDocs(usersQ);

      const userDocs = usersSnap.docs;

      // 3) Write in chunks of 450 to be safe under 500/commit
      const CHUNK = 450;
      for (let i = 0; i < userDocs.length; i += CHUNK) {
        const batch = writeBatch(db);
        const slice = userDocs.slice(i, i + CHUNK);
        slice.forEach((u) => {
          const uref = doc(db, 'users', u.id);
          batch.update(uref, { assignedSiteId: deleteField() });
        });

        // Only delete the site doc on the first batch (or if no users at all)
        if (i === 0) batch.delete(siteRef);

        await batch.commit();
      }

      // If there were zero users to update, we still need to delete the site:
      if (userDocs.length === 0) {
        await deleteDoc(siteRef);
      }

      // Refresh the local sites list
      await fetchSites();

      // If the deleted site was currently selected anywhere, clear it
      if (selectedSiteId === siteId) setSelectedSiteId('');

    } catch (err) {
      console.error('Failed to delete site:', err);
    } finally {
      setDeletingSite(false);
      setOpenDeleteSiteModal(false);
      setDeleteTargetSite(null);
    }
  };



  // Fetch messages
const fetchMessages = async () => {
  setLoading(true);
  const snapshot = await getDocs(collection(db, 'contactUs'));

  const data = snapshot.docs
    .map(doc => doc.data())
    .sort((a, b) => new Date(b.date) - new Date(a.date)); // 🔥 Sort by newest first

  setMessages(data);
  setLoading(false);
};

  
  // Fetch Pending Users
  const fetchPendingUsers = async () => {
    setLoading(true);
    const snapshot = await getDocs(collection(db, 'users'));
    const data = snapshot.docs
      .filter(doc => doc.data().isApproved === false)
      .map(doc => ({ ...doc.data(), id: doc.id }));
    setPendingUsers(data);
    setLoading(false);
  };
  
  // Approve Worker
  const approveUser = async (id, siteId) => {
    if (!siteId) return;

    const userRef = doc(db, 'users', id);
    const userSnap = await getDoc(userRef);
    const userData = userSnap.data();

    // Approve the user and assign the site
    await updateDoc(userRef, {
      isApproved: true,
      assignedSiteId: siteId
    });

    // Send email using callable function
    if (!userData.email) {
      console.error('User has no email in Firestore:', userData);
      return;
    } else {
      console.log('user email is:', userData.email)
    }

    try {
      await sendApprovalEmail({
        email: userData.email,
        fullName: userData.fullName
      });
    } catch (error) {
      console.error('Failed to send approval email:', error);
    }

    // Refresh list
    fetchPendingUsers();
  };

  
  // Reject Worker
  const denyUser = async (id) => {
    try {
      // First delete clocking history subcollection
      const historySnap = await getDocs(collection(db, 'users', id, 'clocking history'));
      for (const docSnap of historySnap.docs) {
        await deleteDoc(doc(db, 'users', id, 'clocking history', docSnap.id));
      }

      // Then delete the user document
      await deleteDoc(doc(db, 'users', id));

      // Refresh the pending users list
      fetchPendingUsers();
    } catch (error) {
      console.error("Error denying and deleting user:", error);
    }
  };
  

  // Fetch places automatically
  useEffect(() => {
    const checkAutocomplete = () => {
      if (window.google && window.google.maps && window.google.maps.places && customElements.get('place-autocomplete')) {
        setAutocompleteReady(true);
        return true;
      }
      return false;
    };

    if (checkAutocomplete()) {
      return;
    }

    const timer = setInterval(() => {
      if (checkAutocomplete()) {
        clearInterval(timer);
      }
    }, 100);

    return () => clearInterval(timer);
  }, []);

  // Update your places useEffect to only run when autocomplete is ready
  useEffect(() => {
    if (!autocompleteReady) return;

    const inputEl = document.getElementById('place-autocomplete');
    if (!inputEl) return;

    const handlePlaceChange = () => {
      const selected = inputEl.gmpPlace;
      if (!selected?.geometry) {
        console.warn("No geometry found in selected place");
        return;
      }

      const lat = selected.geometry.location.lat();
      const lng = selected.geometry.location.lng();
      const addr = selected.formatted_address || inputEl.value;

      setMarker({ lat, lng });
      setPlace(addr);
      map?.panTo({ lat, lng });
    };

    inputEl.addEventListener('gmp-placechange', handlePlaceChange);

    return () => {
      inputEl.removeEventListener('gmp-placechange', handlePlaceChange);
    };
  }, [autocompleteReady, map]);


  // Add these handlers
  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };


  const handleSearch = () => {
    if (!geocoder || !searchAddress.trim()) return;

    setIsSearching(true);
    
    geocoder.geocode({ address: searchAddress }, (results, status) => {
      setIsSearching(false);
      
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        const newMarker = {
          lat: location.lat(),
          lng: location.lng()
        };
        
        setMarker(newMarker);
        setPlace(results[0].formatted_address);
        setMap(map => {
          map?.panTo(newMarker);
          return map;
        });
      } else {
        console.error('Geocode was not successful:', status);
      }
    });
  };

  // Search for Users
  useEffect(() => {
    const query = searchQuery.toLowerCase().trim();
  
    if (!query) {
      setFilteredUsers(users);
      return;
    }
  
    const filtered = users.filter(user => {
      const fullName = user.name.toLowerCase();
      const [first, last] = fullName.split(' ');
      const reversed = `${last} ${first}`.trim();
  
      return fullName.includes(query) || reversed.includes(query);
    });
  
    setFilteredUsers(filtered);
  }, [searchQuery, users]);

  

  // Fetch User's Clocking History
  const fetchUserClockingHistory = async (userId) => {
    setClockingHistoryLoading(true); // <-- ensure loading starts here too

    try {
      const historyRef = collection(db, "users", userId, "clocking history");
      const snapshot = await getDocs(historyRef);
      const entries = snapshot.docs.map((doc) => doc.data());

      const sortedEntries = entries.sort((a, b) => {
        const ta = a.timestamp ? Date.parse(a.timestamp) : 0;
        const tb = b.timestamp ? Date.parse(b.timestamp) : 0;
        return tb - ta;
      });
      setClockingHistory(sortedEntries);

      const userDoc = await getDoc(doc(db, "users", userId));
      return userDoc.exists() ? { id: userId, ...userDoc.data() } : null;
    } catch (error) {
      console.error("Error fetching clocking history or user data:", error);
      return null;
    } finally {
      setClockingHistoryLoading(false); // <-- only turns off after everything finishes
    }
  };


  

  const grouped = {};
  clockingHistory.forEach(entry => {
    const { date, type } = entry;
    if (!grouped[date]) grouped[date] = { date, clockIn: null, clockOut: null };
    if (type === 'Clock In') grouped[date].clockIn = entry;
    if (type === 'Clock Out') grouped[date].clockOut = entry;
  });

  const sortedGrouped = Object.values(grouped).sort((a, b) => {
    // Convert from dd/mm/yyyy to Date objects
    const parse = (d) => {
      const [day, month, year] = d.split('/');
      return new Date(`${year}-${month}-${day}`);
    };
    return parse(b.date) - parse(a.date);
  });

  

  // Delete user from DB
  const deleteUserAndData = async (userId) => {
    try {
      // Delete subcollections (like clocking history)
      const historySnap = await getDocs(collection(db, 'users', userId, 'clocking history'));
      for (const docSnap of historySnap.docs) {
        await deleteDoc(doc(db, 'users', userId, 'clocking history', docSnap.id));
      }

      // Delete the user document
      await deleteDoc(doc(db, 'users', userId));

      // Remove user from UI
      setUsers((prev) => prev.filter((u) => u.id !== userId));
      setFilteredUsers((prev) => prev.filter((u) => u.id !== userId));
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };


  return (
    <Box sx={{ px: 0, py: 2 }}>
      {/* Top Stats */}
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        mb={2}
        gap={2}
        backgroundColor='white'
        padding='15px'
        borderRadius={2}
        boxShadow="0px 4px 8px rgba(0, 0, 0, 0.1)"
      >
        {/* Left: Title */}
        <Typography variant="h4" fontWeight="bold">
         {t('SofBen Dashboard')}
        </Typography>

        {/* Right: Icons + Search Bar */}
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          gap={2}
          width={{ xs: '100%', sm: 'auto' }}
        >
          {/* Search Field stays below or beside it */}
          <TextField
            variant="outlined"
            size="small"
            placeholder={t('Search worker')}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{
              width: { xs: '100%', sm: 250 },
              backgroundColor: 'white',
              borderRadius: 3, 
              '& .MuiOutlinedInput-root': {
                borderRadius: 3, 
              },
            }}
          />
          
          <Box display="flex" alignItems="center" gap={2}>
            {/* Icons here */}
            <Badge
              badgeContent={newUsersCount}
              color="error"
              invisible={newUsersCount === 0}
            >
              <AssignmentIndIcon
                sx={{ cursor: 'pointer', fontSize: 32 }}
                onClick={async () => {
                  setOpenApprovals(true);
                  fetchPendingUsers();
                  const notifRef = doc(db, 'AdminNotifications', 'main');
                  setNewUsersCount(0);
                  await updateDoc(notifRef, { newUsers: 0 });
                }}
              />
            </Badge>

            <Badge badgeContent={newMessagesCount} color="error">
              <EmailIcon
                sx={{ cursor: 'pointer', fontSize: 32 }}
                onClick={async () => {
                  setOpenMessages(true);
                  fetchMessages();
                  const notifRef = doc(db, 'AdminNotifications', 'main');
                  setNewMessagesCount(0);
                  await updateDoc(notifRef, { newMessages: 0 });
                }}
              />
            </Badge>

            <SettingsIcon
              sx={{ cursor: 'pointer', fontSize: 32 }}
              onClick={() => {
                fetchSites();
                setOpenSettings(true);
              }}
            />
          </Box>

        </Box>
      </Box>


      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          mb: 2,
          width: '100%',
        }}
      >
        {/* Clock-Ins Today */}
        <Paper
          elevation={2}
          sx={{
            flex: '1 1 200px',
            minWidth: 200,
            height: 120,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 2,
          }}
        >
          <Typography variant="h3" >{clockInsToday}</Typography>
          <Typography variant="h6" color="text.secondary">
            {t('Clock-Ins Today')}
          </Typography>
        </Paper>

        {/* Active Workers */}
        <Paper
          elevation={2}
          sx={{
            flex: '1 1 200px',
            minWidth: 200,
            height: 120,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 2,
          }}
        >
          <Typography variant="h3">{activeWorkers}</Typography>
          <Typography variant="h6" color="text.secondary">
            {t('Active workers')}
          </Typography>
        </Paper>

        {/* Workers on Time */}
        <Paper
          elevation={2}
          sx={{
            flex: '1 1 200px',
            minWidth: 200,
            height: 120,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 2,
          }}
        >
          <Typography variant="h3">{onTimeWorkers}</Typography>
          <Typography variant="h6" color="text.secondary">
            {t('Workers on time')}
          </Typography>
        </Paper>

        {/* Total Violations */}
        <Paper
          elevation={2}
          sx={{
            flex: '1 1 200px',
            minWidth: 200,
            height: 120,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 2,
          }}
        >
          <Typography variant="h3">{violationsToday}</Typography>
          <Typography variant="h6" color="text.secondary">
            {t('Total violations')}
          </Typography>
        </Paper>
      </Box>


      {/* Table Section */}
      <Paper sx={{ overflowX: 'auto', borderRadius: 2 }}>
        <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Box display="flex" alignItems="center" gap={1} sx={{color: '#737373'}}>
                <PersonIcon />
                <strong>{t('Name')}</strong>
              </Box>
            </TableCell>

            <TableCell>
              <Box display="flex" alignItems="center" gap={1} sx={{color: '#737373'}}>
                <EventAvailableIcon />
                <strong>{t('Clock-In')}</strong>
              </Box>
            </TableCell>

            <TableCell>
              <Box display="flex" alignItems="center" gap={1} sx={{color: '#737373'}}>
                <EventBusyIcon />
                <strong>{t('Clock-Out')}</strong>
              </Box>
            </TableCell>

            <TableCell>
              <Box display="flex" alignItems="center" gap={1} sx={{color: '#737373'}}>
                <QueryBuilderIcon />
                <strong>{t('Hours Worked')}</strong>
              </Box>
            </TableCell>

            <TableCell>
              <Box display="flex" alignItems="center" gap={1} sx={{color: '#737373'}}>
                <EngineeringIcon />
                <strong>{t('Status')}</strong>
              </Box>
            </TableCell>

            {/* Force clock-out button in the table head (near Status) */}
            <TableCell align="center">
              <Box display="flex" justifyContent="center">
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  onClick={handleForceClockOutAll}
                  disabled={forceClockingOut}
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    textTransform: "none",
                    borderRadius: 2,
                    whiteSpace: "nowrap",
                  }}
                >
                  {forceClockingOut ? t("Clocking out...") : t("Force Clock-Out for all")}
                </Button>
              </Box>
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>


          <TableBody>
            {loadingUsers ? (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                  <CircularProgress size={28} />
                </TableCell>
              </TableRow>
            ) : filteredUsers.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 3, color: '#888' }}>
                  {t('No workers found for today.')}
                </TableCell>
              </TableRow>
            ) : (
              filteredUsers.map((user, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: index % 2 === 0 ? 'white' : '#f9f9f9' 
                }}
              >
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar src={worker} alt={user.name} />
                    <Box>
                      <Typography fontWeight="bold" fontSize="0.95rem">
                        {formatWorkerDisplayName(user.name)}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>

                <TableCell>
                  <Box>
                    <Typography fontWeight="bold" fontSize="0.9rem">
                      {normalizeToHMinS(user.clockInTime) || "—"}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {user.clockInLocation || '—'}
                    </Typography>
                  </Box>
                </TableCell>


                <TableCell>
                  <Box>
                    <Typography fontWeight="bold" fontSize="0.9rem">
                      {normalizeToHMinS(user.clockOutTime) || "—"}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {user.clockOutLocation || '—'}
                    </Typography>
                  </Box>
                </TableCell>


                <TableCell> {user.hoursWorked || "—"} </TableCell>


                <TableCell>
                  <Box
                    sx={{
                      display: 'inline-block',
                      backgroundColor: user.isClockedIn ? '#d0f2d8' : '#fef2f2',
                      border: '1px solid',
                      borderColor: user.isClockedIn ? '#d0f2d8' : '#fef2f2',
                      color: user.isClockedIn ? '#008000' : '#b55150',
                      borderRadius: 5,
                      px: 2,
                      py: 0.5,
                      fontSize: '0.8rem',
                      fontWeight: 'bold',
                      textAlign: 'center'
                    }}
                  >
                    {user.isClockedIn ? t('Working') : t('OFF')}
                  </Box>
                </TableCell>



                <TableCell align="center">
                  <Badge
                    variant="dot"
                    color="error"
                    invisible={!usersWithNotesToday.has(user.id)}
                    overlap="circular"
                  >
                  <ManageSearchIcon
                    sx={{ color: 'gray', cursor: 'pointer' }}
                    onClick={async () => {
                      // 1) Put loading ON first (prevents "No history" flash)
                      setClockingHistoryLoading(true);

                      // 2) Reset modal content while loading is ON
                      setClockingHistory([]);
                      setSelectedUserDetails(null);

                      // 3) Open modal AFTER loading is ON
                      setOpenHistoryModal(true);

                      // 4) Fetch data
                      await fetchUserClockingHistory(user.id);

                      // (Optional) If you still want to set details here, keep it,
                      // but note: your fetchUserClockingHistory already fetches userDoc too.
                      const userDoc = await getDoc(doc(db, "users", user.id));
                      if (userDoc.exists()) {
                        setSelectedUserDetails({ id: user.id, ...userDoc.data() });
                      }
                    }}
                  />
                  </Badge>
                </TableCell>

                <TableCell align="center">
                  <DeleteOutlineIcon
                    sx={{ color: 'gray', cursor: 'pointer' }}
                    onClick={() => {
                      setDeleteTargetUser(user.id);
                      setOpenDeleteModal(true);
                    }}
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
        </Table>
      </Paper>

      {/* Settings Modal */}
      <Modal open={openSettings} onClose={() => setOpenSettings(false)}>
          <Box sx={{
            ...modalStyle,
            width: { xs: '75%', sm: '70%' },  
            maxHeight: '75vh',
            overflowY: 'auto',
            p: 4,
            borderRadius: 3,
          }}>
            <IconButton
            onClick={() => setOpenSettings(false)}
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              color: '#999',
              '&:hover': {
                color: '#c93d3d',
              },
            }}
          >
            <CloseIcon />
          </IconButton>

            <Box display="flex" alignItems="center" gap={2} mb={2}>
            <WorkHistoryIcon sx={{ fontSize: 40, color: '#c93d3d' }} />
            <Box>
              <Typography variant="h5" fontWeight="bold">
              {t('Working Hours Information')}
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                {t('Configure lateness rules and expected work times')}
              </Typography>
            </Box>
          </Box>


          <Divider sx={{ mb: 3 }} /> 

          {/* Site Creation Form */} 
          <Box display="flex" flexDirection="column" gap={2} sx={{border: '1px solid black', mb: 2, padding: '15px' }}>
            <Box
              display="flex"
              alignItems="center"
              sx={{ cursor: 'pointer'}}
              onClick={() => setShowSiteForm(prev => !prev)}
            >
              {showSiteForm ? (
                <RemoveCircleIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
              ) : (
                <AddCircleIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
              )}
              <Typography variant="subtitle1" fontWeight="bold">
                {t('Add a new construction site')}
              </Typography>
            </Box>


          {showSiteForm && (
            <>
            <TextField
              label="Site Name"
              value={newSiteName}
              onChange={(e) => setNewSiteName(e.target.value)}
            />
            
            <TextField
              label={t("Site Start Date")}
              type="date"
              value={newSiteStartDate}
              onChange={(e) => setNewSiteStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              label={t("Site End Date")}
              type="date"
              value={newSiteEndDate}
              onChange={(e) => setNewSiteEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              label="Start Time"
              type="time"
              value={newStartTime}
              onChange={(e) => setNewStartTime(e.target.value)}
            />
            <TextField
              label="End Time"
              type="time"
              value={newEndTime}
              onChange={(e) => setNewEndTime(e.target.value)}
            />

            {/* Autocomplete Web Component (no LoadScript!) */}
            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
              <TextField
                fullWidth
                value={searchAddress}
                onChange={(e) => setSearchAddress(e.target.value)}
                placeholder="Enter address (e.g., Algiers, Algeria)"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    height: '42px'
                  }
                }}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              />
              
              <Button 
                variant="contained" 
                onClick={handleSearch}
                disabled={isSearching || !searchAddress.trim()}
                sx={{ height: '42px' }}
              >
                {isSearching ? 'Searching...' : 'Search'}
              </Button>
            </Box>

            {/* Google Map with draggable marker */}
            <GoogleMap
              center={marker}
              zoom={14}
              mapContainerStyle={{ width: '100%', height: '300px', marginTop: 10 }}
              onLoad={(map) => {
                setMap(map);
                setGeocoder(new window.google.maps.Geocoder());
              }}  
              onClick={(e) =>
                setMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() })
              }
            >
              <Marker
                position={marker}
                draggable
                onDragEnd={(e) =>
                  setMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() })
                }
              />
            </GoogleMap>

            <Button
              variant="contained"
              onClick={async () => {
                if (!isFormComplete) return; 

                setIsSubmitting(true);
                try {
                  const siteRef = doc(collection(db, 'ConstructionSites'));
                  await setDoc(siteRef, {
                    name: newSiteName,
                    siteStartDate: newSiteStartDate, 
                    siteEndDate: newSiteEndDate, 
                    startTime: newStartTime,
                    endTime: newEndTime,
                    location: {
                      lat: marker.lat,
                      lng: marker.lng,
                      address: place
                    }
                  });

                  // Reset form
                  setNewSiteName('');
                  setNewSiteStartDate("");
                  setNewSiteEndDate("");
                  setNewStartTime('');
                  setNewEndTime('');
                  setPlace('');
                  setSearchAddress('')
                  fetchSites();
                } catch (error) {
                  console.error('Failed to add site:', error);
                } finally {
                  setIsSubmitting(false);
                }
              }}
              disabled={!isFormComplete || isSubmitting}
            >
              {isSubmitting ? 'Adding...' : 'Add Site'}
            </Button>

            </>
          )}
          </Box>

          {/* Site List Tickets */}
          <Box display="flex" flexDirection="column" gap={2}>
            <Typography fontWeight="bold">{t('All Construction Sites')}</Typography>

            {sites.length === 0 ? (
              <Typography color="text.secondary">No sites created yet.</Typography>
            ) : (
              sites.map((site) => (
              <Box
                key={site.id}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  border: '1px solid #ccc',
                  borderRadius: 2,
                  p: 2,
                  backgroundColor: '#FFF',
                  flexWrap: 'wrap',
                  position: 'relative',
                }}
              >

                {/* Top-right actions: Edit then Delete */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    display: "flex",
                  }}
                >
                  {/* Edit icon */}
                  <IconButton
                    aria-label={t("Edit")}
                    size="small"
                    onClick={() => openEditSite(site)}
                    sx={{
                      color: "#6b7280",
                      "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
                      mr: -1
                    }}
                  >
                    <EditOutlinedIcon fontSize="small" />
                  </IconButton>

                  {/* Delete icon */}
                  <IconButton
                    aria-label={t("Delete")}
                    color="error"
                    size="small"
                    onClick={() => {
                      setDeleteTargetSite({ id: site.id, name: site.name });
                      setOpenDeleteSiteModal(true);
                    }}
                    sx={{
                      "&:hover": { backgroundColor: "rgba(201,61,61,0.08)" },
                    }}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Left side: Name and times */}
                <Box>
                  <Typography fontWeight="bold" fontSize="1.2rem">
                    {site.name}
                  </Typography>

                  <Box display="flex" gap={1} mt={1}>

                      <Box
    sx={{
      backgroundColor: "#f4f4f4",
      color: "#6b7280",
      px: 1.2,
      py: 0.5,
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
    }}
  >
    <Typography variant="body2" fontWeight="bold" sx={{ mr: 1 }}>
      {t("From")}:
    </Typography>
    <Typography variant="body2">{site.siteStartDate || "--"}</Typography>
  </Box>

  <Box
    sx={{
      backgroundColor: "#f4f4f4",
      color: "#6b7280",
      px: 1.2,
      py: 0.5,
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
    }}
  >
    <Typography variant="body2" fontWeight="bold" sx={{ mr: 1 }}>
      {t("To")}:
    </Typography>
    <Typography variant="body2">{site.siteEndDate || "--"}</Typography>
  </Box>

                    <Box
                      sx={{
                        backgroundColor: '#f4f4f4',
                        color: '#006d2c',
                        px: 1,
                        py: 0.5,
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Typography variant="body2" fontWeight="bold" sx={{ mr: 1 }}>
                        {t('Start')}:
                      </Typography>
                      <Typography variant="body2">{site.startTime || '--'}</Typography>
                    </Box>

                    <Box
                      sx={{
                        backgroundColor: '#f4f4f4',
                        color: '#b30000',
                        px: 2,
                        py: 0.5,
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Typography variant="body2" fontWeight="bold" sx={{ mr: 1 }}>
                        {t('End')}:
                      </Typography>
                      <Typography variant="body2">{site.endTime || '--'}</Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Right side: Map and location */}
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Box
                    component="img"
                    src={MapImg}
                    alt="Map Preview"
                    sx={{ width: 50, height: 30, objectFit: 'cover', borderRadius: 1 }}
                  />
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1, maxWidth: 120, textAlign: 'center' }}>
                    {site.location?.address || t('No location specified')}
                  </Typography>
                </Box>
              </Box>
              ))
            )}
          </Box>
        </Box>
      </Modal>

      {/* Edit Construction Site Modal */}
      <Modal open={openEditSiteModal} onClose={() => setOpenEditSiteModal(false)}>
        <Box
          sx={{
            ...modalStyle,
            maxWidth: 520,
            p: 4,
            borderRadius: 3,
            position: "relative",
          }}
        >
          <IconButton
            onClick={() => setOpenEditSiteModal(false)}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "#999",
              "&:hover": { color: "#c93d3d" },
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" fontWeight="bold" mb={2}>
            {t("Edit Construction Site")}
          </Typography>

          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              label={t("Site Name")}
              value={editSiteName}
              onChange={(e) => setEditSiteName(e.target.value)}
            />

            <TextField
              label={t("Site Start Date")}
              type="date"
              value={editSiteStartDate}
              onChange={(e) => setEditSiteStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              label={t("Site End Date")}
              type="date"
              value={editSiteEndDate}
              onChange={(e) => setEditSiteEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
/>

            <TextField
              label={t("Start Time")}
              type="time"
              value={editStartTime}
              onChange={(e) => setEditStartTime(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              label={t("End Time")}
              type="time"
              value={editEndTime}
              onChange={(e) => setEditEndTime(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />

            <Button
              variant="contained"
              onClick={updateConstructionSite}
              disabled={updatingSite || !editSiteName || !editSiteStartDate || !editSiteEndDate || !editStartTime || !editEndTime}
              sx={{ mt: 1 }}
            >
              {updatingSite ? t("Saving...") : t("Save Changes")}
            </Button>
          </Box>
        </Box>
      </Modal>


      {/*Confirm construction site deletion modal */}
      <Modal open={openDeleteSiteModal} onClose={() => setOpenDeleteSiteModal(false)}>
        <Box
          sx={{
            ...modalStyle,
            maxWidth: 420,
            p: 4,
            textAlign: 'center',
            borderRadius: 3
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={2}>
            {t('Delete Construction Site')}
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            {t('This will remove the site')} <strong>{deleteTargetSite?.name}</strong> {t('and clear its assignment from all workers. This action is irreversible.')}
          </Typography>

          <Box display="flex" justifyContent="center" gap={2}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => setOpenDeleteSiteModal(false)}
              disabled={deletingSite}
            >
              {t('Cancel')}
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => deleteConstructionSite(deleteTargetSite.id)}
              disabled={deletingSite}
            >
              {deletingSite ? t('Deleting...') : t('Delete')}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Messages Modal */}
      <Modal open={openMessages} onClose={() => setOpenMessages(false)}>
      <Box
        sx={{
          ...modalStyle,
          maxWidth: 800,
          width: '65%', // responsive width
          maxHeight: '75vh', // prevent modal from exceeding screen height
          overflowY: 'auto', // enable internal scroll
          p: 4,
        }}
      >
          
          {/* Close Icon */}
          <IconButton
            onClick={() => setOpenMessages(false)}
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              color: '#999',
              '&:hover': { color: '#c93d3d' },
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Title and subtitle with icon */}
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <MailOutlineIcon sx={{ fontSize: 40, color: '#c93d3d' }} />
            <Box>
              <Typography variant="h5" fontWeight="bold">
                {t('Incoming Messages')}
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                {t('Review contact messages submitted by users')}
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ mb: 1 }} />

          {/* Styled Table */}
          <Table sx={{ border: '3px solid #eee', borderRadius: 2, overflow: 'hidden' }}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <PersonIcon fontSize="small" sx={{ mr: 1 }} />
                    <strong>{t('Full Name')}</strong>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <EmailIcon fontSize="small" sx={{ mr: 1 }} />
                    <strong>{t('Email')}</strong>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <PhoneAndroidIcon fontSize="small" sx={{ mr: 1 }} />
                    <strong>{t('Phone')}</strong>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <CalendarTodayIcon fontSize="small" sx={{ mr: 1 }} />
                    <strong>{t('Date')}</strong>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <MessageIcon fontSize="small" sx={{ mr: 1 }} />
                    <strong>{t('Message')}</strong>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
                    <Box display="flex" justifyContent="center">
                      <CircularProgress size={28} />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : messages.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 3, color: '#888' }}>
                    {t('No messages found.')}
                  </TableCell>
                </TableRow>
              ) : (
                messages.map((m, i) => (
                  <TableRow key={i} >
                    <TableCell>{m.fullName}</TableCell>
                    <TableCell>{m.email}</TableCell>
                    <TableCell>{m.phone}</TableCell>
                    <TableCell>{m.date?.slice(0, 10)}</TableCell>
                    <TableCell>{m.message}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Box>
      </Modal>

      {/* Approvals Modal */}
      <Modal open={openApprovals} onClose={() => setOpenApprovals(false)}>
        <Box
          sx={{
            ...modalStyle,
            maxWidth: 800,
            width: '65%',
            maxHeight: '85vh',
            overflowY: 'auto',
            p: 4,
            position: 'relative',
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={() => setOpenApprovals(false)}
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              color: '#999',
              '&:hover': { color: '#c93d3d' },
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Header */}
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <PersonAddAltIcon sx={{ fontSize: 40, color: '#c93d3d' }} />
            <Box>
              <Typography variant="h5" fontWeight="bold">{t('Pending Approvals')}</Typography>
              <Typography variant="subtitle2" color="text.secondary">
                {t('Review and approve or deny newly registered workers')}
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Conditional Content */}
          {pendingUsers.length === 0 ? (
            <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ mt: 5, mb: 3 }}>
              {t('There are no users awaiting approval.')}
            </Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>{t('Name')}</strong></TableCell>
                  <TableCell><strong>{t('Email')}</strong></TableCell>
                  <TableCell><strong>{t('Phone')}</strong></TableCell>
                  <TableCell><strong>{t('Date')}</strong></TableCell>
                  <TableCell><strong>{t('Site')}</strong></TableCell> 
                  <TableCell><strong>{t('Actions')}</strong></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
                      <CircularProgress size={28} />
                    </TableCell>
                  </TableRow>
                ) : pendingUsers.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 3, color: '#888' }}>
                      {t('There are no users awaiting approval.')}
                    </TableCell>
                  </TableRow>
                ) : (
                  pendingUsers.map((u, i) => (
                    <TableRow key={i}>
                      <TableCell>{u.fullName}</TableCell>
                      <TableCell>{u.email}</TableCell>
                      <TableCell>{u.phone}</TableCell>
                      <TableCell>{u.date?.slice(0, 10)}</TableCell>
                      <TableCell>
                        <TextField
                          select
                          size="small"
                          value={siteAssignments[u.id] || ''}
                          onChange={(e) =>
                            setSiteAssignments((prev) => ({
                              ...prev,
                              [u.id]: e.target.value
                            }))
                          }
                          SelectProps={{ native: true }}
                          sx={{ backgroundColor: 'white' }}
                        >
                          <option value="">-- {t('Select Site')} --</option>
                          {sites.map((site) => (
                            <option key={site.id} value={site.id}>
                              {site.name}
                            </option>
                          ))}
                        </TextField>
                      </TableCell>
                      <TableCell>
                        <Box sx={{display:"flex"}}>
                        <Button
                          size="small"
                          color="success"
                          variant="outlined"
                          onClick={() => approveUser(u.id, siteAssignments[u.id])}
                          disabled={!siteAssignments[u.id]}
                          sx={{ mr: 1 }}
                        >
                          {t('Approve')}
                        </Button>
                        <Button
                          size="small"
                          color="error"
                          variant="outlined"
                          onClick={() => denyUser(u.id)}
                        >
                          {t('Deny')}
                        </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}
        </Box>
      </Modal>

      <WorkerClockingHistoryModal
        open={openHistoryModal}
        onClose={() => setOpenHistoryModal(false)}
        userId={selectedUserDetails?.id}
        sites={sites}
        workerProfileImg={workerProfile}
        emptyImg={emptyImage}
        t={t}
      />


      {/* Condirm user deletion Modal*/}
      <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
        <Box
          sx={{
            ...modalStyle,
            maxWidth: 400,
            p: 4,
            textAlign: 'center',
            borderRadius: 3
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={2}>
            {t('Confirm Deletion')}
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={3}>
            {t('Are you sure you want to delete this user and all related data? This action is irreversible.')}
          </Typography>

          <Box display="flex" justifyContent="center" gap={2}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => setOpenDeleteModal(false)}
            >
              {t('Cancel')}
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={async () => {
                await deleteUserAndData(deleteTargetUser);
                setOpenDeleteModal(false);
              }}
            >
              {t('Delete')}
            </Button>
          </Box>
        </Box>
      </Modal>

    </Box>
  );
}

export default AdminClockingReport;
